const DocumentDownloadPreferences = ["PDF", "ORIGINAL"] as const;

export type DocumentDownloadPreference = typeof DocumentDownloadPreferences[number];

export type DocumentDownloadPreferenceOption = {
  id: DocumentDownloadPreference,
  displayText: string,
};

export function toDocumentDownloadPreferenceOption(documentDownloadPreference: DocumentDownloadPreference): DocumentDownloadPreferenceOption {
  return {
    id: documentDownloadPreference,
    displayText: getDocumentDownloadPreferenceDisplayText(documentDownloadPreference),
  };
}

function getDocumentDownloadPreferenceDisplayText(documentDownloadPreference: DocumentDownloadPreference): string {
  switch (documentDownloadPreference) {
    case "PDF":
      return "Convert to PDF";
    case "ORIGINAL":
      return "Original file format";
  }
}

export function getDocumentDownloadPreferenceFormatOptions(): Array<DocumentDownloadPreferenceOption> {
  return DocumentDownloadPreferences.map(toDocumentDownloadPreferenceOption);
}
